import { useDialogContext } from '../../../contexts/DialogContext';
import { window } from '../../../globals';
import { getAuthorizeServiceURL } from '../../../helpers/services';
import { post } from '../../../redux/api';
import Icon, { icons } from '../../generic/Icon';

const BitbucketSettings = () => {
  const { onConfirm } = useDialogContext();

  return (
    <div>
      <div className="text-center margin-bottom-sm">
        <h1>Bitbucket Cloud Login</h1>
        <p>FOSSA allows users to link a Bitbucket Cloud login to their FOSSA login.</p>
      </div>
      <div className="card">
        {!window.user.bitbucketCloud ? (
          <div className="service-connected-container">
            <h4>You are not connected to Bitbucket</h4>
            <a
              href={getAuthorizeServiceURL({
                vcsHost: 'bitbucket_cloud',
                location: window.location.href,
                serviceConnect: true,
              })}
              className="btn btn-service-connect">
              <Icon icon={icons.bitbucket} />&nbsp;Connect to Bitbucket Cloud
            </a>
          </div>
        ) : (
          <div className="service-connected-container">
            <h4>
              You are currently connected{' '}
              {window.user.bitbucketCloud.name ? (
                <span>
                  as <b>{window.user.bitbucketCloud.name}</b>
                </span>
              ) : (
                <span>to Bitbucket Cloud</span>
              )}
            </h4>
            <button
              type="button"
              onClick={() => {
                onConfirm({
                  title: 'Confirm Bitbucket Cloud disconnect',
                  body: (
                    <div>
                      <p>
                        <b>
                          Are you sure you want to disassociate the current user with the registered BitBucket Cloud
                          account?
                        </b>{' '}
                        (cannot be undone)
                      </p>
                    </div>
                  ),
                  onConfirm: async () => {
                    await post('/api/services/bitbucket_cloud/disconnectService', undefined);
                    window.location.reload();
                  },
                });
              }}
              className="btn btn-primary btn-service-login-disconnect">
              Disconnect
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BitbucketSettings;
